module.exports = __webpack_public_path__ + "fromBrideToFather-we-b.a7bf8d47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-we-b.jpg
// module id = Z+aS
// module chunks = 0